import { NotehubAuth } from "@adapters/NotehubAuth";
import { Config } from "@configured/EnvironmentConfig";

export const CNotehubAuth = new NotehubAuth({
  notehubBaseURL: new URL(Config.notehubAuthBase),
});
